/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AgentPolicyGrantForm,
  AgentPolicyGrantForm$Outbound,
  AgentPolicyGrantForm$outboundSchema,
} from "./agentpolicygrantform.js";

export type RotateKeyForm = {
  /**
   * Delegated policy format version
   */
  delegatedGrantsVersion: number;
  /**
   * Replacement expiry; defaults to 90 days and cannot exceed one year
   */
  expiresAt?: Date | undefined;
  /**
   * API key identifier to replace
   */
  id: string;
  /**
   * The name of the replacement key
   */
  name: string;
  /**
   * New exact allow grants approved for the replacement credential
   */
  requestedGrants: Array<AgentPolicyGrantForm>;
  /**
   * Legacy transport scopes; agent rotation requires an empty array
   */
  scopes?: Array<string> | undefined;
};

/** @internal */
export type RotateKeyForm$Outbound = {
  delegated_grants_version: number;
  expires_at?: string | undefined;
  id: string;
  name: string;
  requested_grants: Array<AgentPolicyGrantForm$Outbound>;
  scopes?: Array<string> | undefined;
};

/** @internal */
export const RotateKeyForm$outboundSchema: z.ZodMiniType<
  RotateKeyForm$Outbound,
  RotateKeyForm
> = z.pipe(
  z.object({
    delegatedGrantsVersion: z.int(),
    expiresAt: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    id: z.string(),
    name: z.string(),
    requestedGrants: z.array(AgentPolicyGrantForm$outboundSchema),
    scopes: z.optional(z.array(z.string())),
  }),
  z.transform((v) => {
    return remap$(v, {
      delegatedGrantsVersion: "delegated_grants_version",
      expiresAt: "expires_at",
      requestedGrants: "requested_grants",
    });
  }),
);

export function rotateKeyFormToJSON(rotateKeyForm: RotateKeyForm): string {
  return JSON.stringify(RotateKeyForm$outboundSchema.parse(rotateKeyForm));
}
